const plattegronden = [
  {
    name: 'Plattegrond Amsterdam',
    description: [
      'Een stijlvolle 3D-plattegrond van Amsterdam.',
      'Ook andere steden of wijken mogelijk op aanvraag.'
    ],
    dimensions: '40x40x2cm',
    images: [
      require('../../images/plattegronden/plattegrond_1A.png'),
    ],
    stl: '/products/plattegronden/voorbeeld-plattegrond.stl',
    contactLink: '/contact?product=Plattegrond%20Amsterdam',
    price: '29,99',
  },
  // Voeg hier meer plattegronden toe
];

export default plattegronden; 